const BASE = process.env.REACT_APP_API_BASE_URL || ""

// credentials: "include" is a no-op same-origin but required when the app is
// served from another occluded.app subdomain (the session cookie lives on
// .occluded.app).
export const fetchMe = () =>
  fetch(`${BASE}/auth/me`, { credentials: "include" })
    .then((r) => (r.ok ? r.json() : { user: null }))
    .then((body) => body.user)
    .catch(() => null)

export const logout = () =>
  fetch(`${BASE}/auth/logout`, { method: "POST", credentials: "include" })

// Full-page navigation (not fetch): the login flow is a chain of redirects
// through Google that must own the whole window. `next` brings the user back
// to where they clicked.
export const loginUrl = () =>
  `${BASE}/auth/login?next=${encodeURIComponent(window.location.href)}`
